import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-slate-950">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-400">
            Don't just take our word for it - hear from the customers who trust 
            ADP Motors & Recovery for their vehicle recovery needs
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-xl p-8 hover:border-blue-500/50 transition-all duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-blue-600/20">
                <Quote className="w-12 h-12" fill="currentColor" />
              </div>

              {/* Rating */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-500 fill-current" />
                ))}
              </div>

              {/* Comment */}
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                "{testimonial.comment}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-between border-t border-slate-800 pt-4">
                <div>
                  <p className="text-white font-bold">{testimonial.name}</p>
                  <p className="text-gray-500 text-sm">{testimonial.location}</p>
                </div>
                <p className="text-gray-500 text-sm">{testimonial.date}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-slate-900/30 border border-slate-800 rounded-xl p-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <p className="text-4xl font-bold text-blue-500 mb-2">4.9</p>
                <p className="text-gray-400">Average Rating</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-blue-500 mb-2">500+</p>
                <p className="text-gray-400">Happy Customers</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-blue-500 mb-2">100%</p>
                <p className="text-gray-400">Satisfaction Rate</p>
              </div>
              <div>
                <p className="text-4xl font-bold text-blue-500 mb-2">24/7</p>
                <p className="text-gray-400">Always Available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
